import React from 'react';
import PropTypes from 'prop-types';
import { Select as AntSelect } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

// Filtro padrão para busca: usa label ou children do option (Ant Design 5 com Option filhos).
// Sem isso, o search no multiselect/select pode não filtrar ao digitar.
const defaultFilterOption = (input, option) => {
  const label = option?.label ?? option?.children;
  if (label == null) return false;
  const text = typeof label === 'string' ? label : (label?.props?.children ?? String(label));
  return String(text).toLowerCase().includes((input || '').toLowerCase());
};

const Select = ({ value, onChange, options, placeholder, mode, style, className, disabled = false, loading = false, allowClear, showSearch = true, filterOption, autoClearSearchValue, ...props }) => {
  const { theme, whitelabelEnabled } = useTheme();

  // Handler específico para onChange
  const handleChange = (newValue) => {
    onChange?.(newValue);
  };

 // Estilos baseados no estado disabled
 const getSelectStyle = () => {
  const baseStyle = {
    width: '100%',
    ...style
  };

  if (disabled) {
    return {
      ...baseStyle,
      backgroundColor: theme.background || '#f5f5f5',
      color: theme.textSecondary || '#999',
      cursor: 'not-allowed',
      opacity: 0.6,
      pointerEvents: 'none'
    };
  }

  // Só aplicar cores customizadas se whitelabel estiver ativo
  if (whitelabelEnabled) {
    return {
      ...baseStyle,
      backgroundColor: theme.selectBackground || theme.inputBackground || theme.white,
      color: theme.textSecondary
    };
  }

  return baseStyle;
};

  return (
    <AntSelect
      value={value}
      onChange={disabled ? undefined : handleChange}
      placeholder={placeholder}
      mode={mode}
      style={getSelectStyle()}
      className={className}
      disabled={disabled}
      loading={loading}
      allowClear={allowClear}
      showSearch={showSearch}
      filterOption={filterOption !== undefined ? filterOption : (showSearch ? defaultFilterOption : undefined)}
      autoClearSearchValue={autoClearSearchValue !== undefined ? autoClearSearchValue : false}
      {...props}
    >
      {options?.map(({ label, value, ...rest }) => (
        <AntSelect.Option key={value} value={value} {...rest}>
          {label}
        </AntSelect.Option>
      ))}
    </AntSelect>
  );
};

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  placeholder: PropTypes.string,
  mode: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  showSearch: PropTypes.bool,
  filterOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

export default Select; 